// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import PointsExplorer from './components/PointsExplorer';
import PointsCalculator from './components/PointsCalculator';
import { OfflineIndicator, InstallPrompt } from './components/shared/FormComponents';

const Navigation = () => {
  const location = useLocation();
  
  const navItems = [
    { path: '/', label: 'Explorer', description: 'Look up points schedules' },
    { path: '/calc', label: 'Calculator', description: 'Calculate points for your show' }
  ];

  return (
    <nav className="bg-white rounded-2xl shadow-lg mb-6 sm:mb-8 overflow-hidden border border-gray-100">
      <div className="grid grid-cols-2">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`px-4 py-3 sm:px-6 sm:py-4 text-center transition-all duration-200 ${
                isActive
                  ? 'bg-gradient-to-r from-purple-500 to-indigo-500 text-white'
                  : 'text-gray-600 hover:bg-purple-50 hover:text-purple-600'
              }`}
            >
              <div className="font-semibold text-base sm:text-lg">{item.label}</div>
              <div className={`text-xs sm:text-sm ${isActive ? 'text-purple-100' : 'text-gray-500'}`}>
                {item.description}
              </div>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

const AppHeader = () => (
  <div className="bg-gradient-to-r from-purple-600 to-indigo-600 rounded-2xl shadow-xl mb-6 sm:mb-8 overflow-hidden">
    <div className="px-4 py-6 sm:px-6 sm:py-8 text-center text-white">
      <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight mb-2">Points Tool</h1>
      <p className="text-purple-100 text-base sm:text-lg font-medium">Championship Points Explorer & Calculator</p>
    </div>
  </div>
);

const App = () => {
  return (
    <Router>
      <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50">
        <OfflineIndicator />
        <InstallPrompt />
        <div className="container mx-auto px-4 py-4 sm:py-6 max-w-7xl">
          <AppHeader />
          <Navigation />
          
          <Routes>
            <Route path="/" element={<PointsExplorer />} />
            <Route path="/calc" element={<PointsCalculator />} />
          </Routes>
          
          {/* Footer */}
          <div className="mt-6 sm:mt-8 bg-white rounded-2xl shadow-lg p-4 sm:p-6 border border-gray-100">
            <h3 className="text-base sm:text-lg font-semibold text-gray-800 mb-3 sm:mb-4 flex items-center">
              <div className="w-1 h-4 sm:h-5 bg-gradient-to-b from-purple-500 to-indigo-500 rounded-full mr-3"></div>
              Disclaimer
            </h3>
            <div className="text-xs sm:text-sm text-gray-600 leading-relaxed space-y-2 sm:space-y-3">
              <p>This application and its creators are not affiliated with, associated with, authorized, endorsed by, or in any way officially connected with the American Kennel Club, Inc. ("AKC"). The official AKC website can be found at www.akc.org.</p>
              <p>The names "American Kennel Club" and "AKC," as well as any related names, marks, emblems, and images, are registered trademarks of their respective owners.</p>
              <p>All data and information provided by this application are for general informational purposes only. While we strive to ensure the information is accurate and up-to-date, we make no representations or warranties of any kind, express or implied, about the completeness, accuracy, reliability, or availability of the information contained herein.</p>
              <p>Any reliance you place on such information is therefore strictly at your own risk. You are strongly encouraged to confirm all information directly with the official premium list for an event or the AKC website.</p>
            </div>
          </div>
        </div>
      </div>
    </Router>
  );
};

export default App;